import { Outlet } from '@remix-run/react'

import { Footer } from '../components/footer.js'
import { Header } from '../components/header.js'
import { PageContainer } from '../components/page-container.js'

export default function AppointmentsLayout(): React.ReactNode {
  return (
    <PageContainer>
      <Header />

      <main className='flex grow flex-col'>
        <Outlet />
      </main>

      <Footer />
    </PageContainer>
  )
}
